import { LinkedTestType } from "@/features/modules/testType/objects/LinkedTestType";

export class TestTypeCategoryWithTestTypes {
  public id = "new";
  public name: string | undefined = undefined;
  public testTypes: LinkedTestType[] = [];
}
